import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// Defined in general.js
/* global setHeaderMMILink dcAnalytics toast scrollToPageTop getFavList */
import PureRenderMixin from '../common/external-adapters/pureRenderMixinAdapter.js';
import { GiveWidgetMixin } from '../common/GiveWidgetMixin.js';
import { getURLParam } from '../adapters/dupes/queryParams.js';

// These require("extlib...") calls logically belong here, but they're actually included in searchPage.js for technical reasons
// '../../../external/jquery/jquery-ajaxq-end.js';

import { detectLocation } from '../common/detectLocation.js';
import { onSignInOutExecute } from '../common/onSignInOutExecute.js';
import { MobileMixin } from '../common/MobileMixin.js';
import { setup, load } from '../common/followList.js';
import { UserSmsInfoMixin } from '../common/sms/UserSmsInfoMixin.js';
import shuffleSearchResults from '../common/shuffleSearchResults.js';
import SearchLayout from './searchLayout.js';
import SearchLayoutMobile from './searchLayoutMobile.js';
import {
    unescapeBreadcrumb,
    processFacetCounts,
    teacherSearchOnly,
    schoolSearchOnly,
    makeSearchURL,
    convertToApiURL,
    convertToTeacherSearchURL,
    convertToSchoolSearchURL,
    convertToEssentialsListSearchURL,
    trackProjectSearchResults,
    hasNonTeacherSchoolFilters,
    essentialsListSearchOnly,
    essentialsPerPage,
} from '../common/searchRequestUtils.js';
import { setPageTitle } from './BreadcrumbUtils.js';
import onCartUpdated from '../common/onCartUpdated.js';
import handlePopState from './searchHistory.js';
import { SearchContext } from '../common/SearchContext.js';
import { getPage } from '../common/requestUtils.js';
import { sendToMap, shouldSendSearchToMap } from './locationSearchToMap.js';

export default createReactClass({

    propTypes: {
        // For server-side rendering, only filterCategories is required
        searchURL: PropTypes.string.isRequired,
        filterCategories: PropTypes.array.isRequired,
        extraFilters: PropTypes.array.isRequired,
        initialProjects: PropTypes.object,
        initialDetectedLocation: PropTypes.object,
        isMapFeatureEnabled: PropTypes.bool,
        perPage: PropTypes.number,
        baseSearchURL: PropTypes.string,
        isEssentialsListsEnabled: PropTypes.bool.isRequired,
    },

    getDefaultProps: function () {
    // List of {value, name, hidden} sort options in the order they should be displayed
    // Hidden sortOptions are supported, but only accessible via entering sortBy={value} into the url directly
        const sortOptions = [
            {
                value: 0,
                hidden: false,
                name: 'most urgent',
                description:
                    <div>most urgent
                        <em>(lowest cost to complete + highest economic need + fewest days left)</em>
                    </div>,
            },
            { value: 2, hidden: false, name: 'lowest cost to complete' },
            { value: 1, hidden: false, name: 'highest economic need' },
            { value: 3, hidden: false, name: 'fewest days left' },
            { value: 4, hidden: false, name: 'most donors' },
            { value: 7, hidden: false, name: 'newest' },
            { value: 8, hidden: true, name: 'number of students' },
        ];

        return {
            sortOptions: sortOptions,
            perPage: 10,
            baseSearchURL: baseURL + 'donors/search.html',
        };
    },

    mixins: [
        PureRenderMixin,
        GiveWidgetMixin,
        MobileMixin,
        UserSmsInfoMixin,
    ],

    convertProjectDataToState: function (data) {
        unescapeBreadcrumb(data.breadcrumb);

        const newState = {
            projects: data,
            loadingProjects: false,
        };

        // Process facet counts data so it makes more sense.
        const counts = data.facetCounts;
        if (counts) {
            newState.facetCounts = processFacetCounts(counts);
            delete data.facetCounts;
        }

        return newState;
    },

    /**
     * Triggers browser effects that should happen when there's a new "page" load
     * @param data Either projects or essentials response data
     */
    browserEffectsForPrimarySearchData: function (data) {
        const { breadcrumb, expandedLocationMessage, proposals, essentialsLists } = data;
        const results = proposals || essentialsLists || [];

        setPageTitle(breadcrumb, this.state.searchURL);

        if (typeof dcAnalytics !== 'undefined') {
            const wasExpanded = !!expandedLocationMessage;
            const hasResults = wasExpanded
                // This depends on the wording of the text, which isn't ideal, but works
                ? expandedLocationMessage.indexOf('To find more') > -1
                : results.length > 0;

            this.trackPageLoad(this.state.searchURL, hasResults, wasExpanded);
        }

        this.recordSearchView();
    },

    /**
     * If the user is logged in, sends a request to the server to record that they viewed this search.
     * If it matches one of their saved searches, we'll updated its last viewed date.
     *
     * NOTE: If we switch to server-rendering all initial search results, we should double check that
     * the initial search still gets recorded when the JS loads in the browser.
     */
    recordSearchView() {
        if (this.state.user) {
            $.post({

                url: `${secureBaseURL}common/record-favorite-view.json`,
                data: {
                    searchURL: this.state.searchURL,
                },
                // Include cookies because we're making a user-specific request against `secure`
                xhrFields: { withCredentials: true },
            });
            // We ignore the response since we're just making an update in the background
        }
    },

    // Callbacks
    handleProjectResponse: function (data) {
        if (typeof $ === 'function' && $.ajaxq.hasNextInQueue('loadingProjects')) {
            return; // Don't render data if another request is pending
        }

        this.setState(
            this.convertProjectDataToState(data),
            this.scrollAfterLoading,
        );

        this.browserEffectsForPrimarySearchData(data);

        trackProjectSearchResults(data.proposals, 'donorSearchPage');
    },

    // TODO: if we make essentials permanent, we should make them respect the shuffle setting as well
    shuffleSearchProjects: function (data) {
        data.proposals = shuffleSearchResults(data.proposals, this.getPerPage());
        this.handleProjectResponse(data);
    },

    handleTeacherResponse: function (data) {
        if ($.ajaxq.hasNextInQueue('loadingTeachers')) {
            return; // Don't render data if another request is pending
        }
        this.setState({
            teachers: data,
            loadingTeachers: false,
        }, this.scrollAfterLoading);

        const state = this.state;
        if (teacherSearchOnly(state.searchURL)) {
            const hasResults = data.length > 0;
            this.trackPageLoad(state.searchURL, hasResults);
        }
    },

    handleSchoolResponse: function (data) {
        if ($.ajaxq.hasNextInQueue('loadingSchools')) {
            return; // Don't render data if another request is pending
        }
        this.setState({
            schools: data,
            loadingSchools: false,
        }, this.scrollAfterLoading);

        const state = this.state;
        if (schoolSearchOnly(state.searchURL)) {
            const hasResults = data.length > 0;
            this.trackPageLoad(state.searchURL, hasResults);
        }
    },

    handleEssentialsListResponse: function (data) {
        if ($.ajaxq.hasNextInQueue('loadingEssentialsLists')) {
            return; // Don't render data if another request is pending
        }

        const searchURL = this.state.searchURL;
        const max = essentialsPerPage(searchURL, this.getPerPage());

        if (getPage(searchURL) === 1) {
            data.essentialsLists = shuffleSearchResults(data.essentialsLists, max);
        }

        // If we add facets as well, we might want to unify this with use of convertProjectDataToState
        unescapeBreadcrumb(data.breadcrumb);

        const exclusive = essentialsListSearchOnly(searchURL);
        const clonedContext = Object.assign({}, this.state.context, {
            essentialsData: data,
            essentialsOnly: exclusive,
        });

        this.setState({
            context: clonedContext,
            loadingEssentialsLists: false,
        }, this.scrollAfterLoading);

        if (exclusive) {
            this.browserEffectsForPrimarySearchData(data);
        }
    },

    trackPageLoad: function (searchURL, hasResults, wasExpanded) {
        if (!hasResults && !wasExpanded) {
            dcAnalytics.trackEventGA(['search', 'no results']);
            dcAnalytics.track('no results');
        }

        const trackingURL = this.getSearchGATracking(searchURL, !hasResults, wasExpanded);
        dcAnalytics.trackPageViewGA(trackingURL);
        dcAnalytics.track('searchPage', {
            url: trackingURL,
        });
    },

    getSearchGATracking: function (fullURL, noResults, wasExpanded) {
        const noResultsText = wasExpanded ? 'no-results-expanded' : 'no-results';
        const urlArray = (fullURL.split('#')[0]).split('?');
        let gaTerms = (urlArray.length > 1) ? urlArray[1] : '';

        if (noResults) {
            const conCat = (gaTerms !== '') ? '&' : '';
            gaTerms = noResultsText + '=true' + conCat + gaTerms;
        }

        let gaString = gaTerms.replace(/keywords=.*?&/, '').replace(/[=&]/g, '+');
        if (gaString !== '') { gaString = 'cat=' + gaString; }
        if (gaTerms.indexOf('keywords=') > -1) {
            if (gaString !== '') {
                gaString += '&';
            }
            gaString += 'keywords=';
            if (noResults) {
                gaString += noResultsText + ':';
            }
            gaString += getURLParam(fullURL, 'keywords');
        }
        return '/donors/search.html' + ((gaString !== '') ? '?' + gaString : '');
    },

    scrollAfterLoading: function () {
        // We don't want to move the page if more results are still loading,
        // or if you're in expanded mobile filters and might be applying more
        if (!this.isLoading() && !this.state.showMobileFilters) {
            scrollToPageTop();
        }
    },

    /**
     * This method updates the searchURL to contain the new params
     * @param {object} params map of params:values to add/remove to/from the URL
     * @param {string} [searchURL] searchURL override
     * @returns {string} A new search api query URL
     */
    makeSearchURL: function (params, searchURL) {
        return makeSearchURL(params, searchURL || this.state.searchURL, this.props.filterCategories);
    },

    /**
     * @param {string} searchURL
     * @param {number} [max]
     * @return {string}
     */
    convertToApiURL: function (searchURL, max) {
        return convertToApiURL(searchURL, this.getPerPage(), max);
    },

    convertToTeacherSearchURL: function (searchURL) {
        return convertToTeacherSearchURL(searchURL, this.getPerPage());
    },

    convertToSchoolSearchURL: function (searchURL) {
        return convertToSchoolSearchURL(searchURL, this.getPerPage());
    },

    convertToEssentialsListSearchURL: function (searchURL) {
        return convertToEssentialsListSearchURL(searchURL, this.getPerPage());
    },

    getPerPage: function () {
        return parseInt(getURLParam(this.props.searchURL, 'max'), 10) || this.props.perPage;
    },

    requestUpdates: function (url, callback, loadingType) {
        this.setState({
            [loadingType]: true,
        });

        $.ajaxq(loadingType, {
            type: 'get',
            url,
            cache: true,
            dataType: 'json',
            success: callback,
            error: () => {
                if ($.ajaxq.hasNextInQueue(loadingType)) {
                    // If we send two requests in quick succession, the first will often fail.
                    // That's fine, because we only need the results from the second one
                    return;
                }
                toast('There was a problem loading more results. Please try again later.');
                this.setState({
                    [loadingType]: false,
                });
            },
        });
    },

    applyFilters: function (params) {
        const searchURL = this.makeSearchURL(params);
        this.changeURL(searchURL);
    },

    changeURL: function (searchURL, isPopState) {
        const oldSearchURL = this.state.searchURL;
        // Only hit the server if meaningful filters were changed
        if (oldSearchURL !== searchURL) {
            // For use by code outside React
            // eslint-disable-next-line no-undef
            searchURLString = searchURL;

            const newState = {
                searchURL,
            };

            this.setState(newState);

            if (!isPopState) {
                history.pushState(null, null, searchURL);
            }

            if (shouldSendSearchToMap(searchURL, this.state.context)) {
                sendToMap(searchURL);
            } else {
                this.makeRequests(searchURL);
            }
        }
    },

    clearProjectData: function () {
        this.setState({
            projects: {},
            facetCounts: undefined,
            loadingProjects: false,
        });
    },

    clearSchoolData: function () {
        this.setState({ schools: [] });
    },

    clearTeacherData: function () {
        this.setState({ teachers: [] });
    },
    clearEssentialsListData: function () {
        const clonedContext = Object.assign({}, this.state.context);
        clonedContext.essentialsData = {};

        this.setState({ context: clonedContext });
    },

    /**
     * Requests project, school, and teacher search results as appropriate
     * The default is projects, but users can specify to only search for teachers or schools
     * Even for project searches, we also search for a couple teachers to display at the top
     * @param searchURL The search page URL
     * @param shouldShuffle Whether to randomly select the projects to display.
     *        This can be useful if we're anticipating high volume and want donations to be spread out.
     * @param prerenderedProjects Projects that were rendered server-side
     *        and thus don't need to be re-queried on the initial load
     */
    makeRequests: function (searchURL, shouldShuffle = false, prerenderedProjects) {
        const schoolsOnly = schoolSearchOnly(searchURL);
        const teachersOnly = teacherSearchOnly(searchURL);
        const essentialsListsOnly = essentialsListSearchOnly(searchURL);

        // If there are filters besides keywords or tracking params, don't show teacher/school results
        // Those filters don't apply to schools and teachers, so the results wouldn't really make sense
        const hideTeachersAndSchools = !schoolsOnly && !teachersOnly && hasNonTeacherSchoolFilters(searchURL);

        const teacherSearchURL = this.convertToTeacherSearchURL(searchURL);
        if (teacherSearchURL && !schoolsOnly && !hideTeachersAndSchools && !essentialsListsOnly) {
            this.requestUpdates(teacherSearchURL, this.handleTeacherResponse, 'loadingTeachers');
            if (teachersOnly) {
                this.clearProjectData();
                this.clearSchoolData();
                this.clearEssentialsListData();
                return;
            }
        } else {
            this.clearTeacherData();
        }

        const schoolSearchURL = this.convertToSchoolSearchURL(searchURL);
        if (schoolSearchURL && !teachersOnly && !hideTeachersAndSchools && !essentialsListsOnly) {
            this.requestUpdates(schoolSearchURL, this.handleSchoolResponse, 'loadingSchools');
            if (schoolsOnly) {
                this.clearProjectData();
                this.clearTeacherData();
                this.clearEssentialsListData();
                return;
            }
        } else {
            this.clearSchoolData();
        }

        if (this.state.context.isEssentialsListsEnabled) {
            const essentialsListSearchURL = this.convertToEssentialsListSearchURL(searchURL);

            if (essentialsListSearchURL && !teachersOnly && !schoolsOnly) {
                this.requestUpdates(essentialsListSearchURL, this.handleEssentialsListResponse, 'loadingEssentialsLists');

                if (essentialsListsOnly) {
                    this.clearProjectData();
                    this.clearTeacherData();
                    this.clearSchoolData();
                    return;
                }
            } else {
                this.clearEssentialsListData();
            }
        } else {
            this.clearEssentialsListData();
        }

        if (prerenderedProjects) {
            this.browserEffectsForPrimarySearchData(prerenderedProjects);
        } else {
            if (shouldShuffle) {
                const apiURL = this.convertToApiURL(searchURL, this.getPerPage() * 2);
                this.requestUpdates(apiURL, this.shuffleSearchProjects, 'loadingProjects');
            } else {
                const apiURL = this.convertToApiURL(searchURL, this.getPerPage());
                this.requestUpdates(apiURL, this.handleProjectResponse, 'loadingProjects');
            }
        }
    },

    popState: function (searchURL) {
        this.changeURL(searchURL, true);
    },

    loadFollowList: function (isMore) {
        load(
            isMore && this.state.followList.searches,
            data => {
                if (isMore) {
                    // Add new searches to a copy of the current followList data
                    const oldFavorites = this.state.followList;
                    const newSearches = oldFavorites.searches.concat(data.searches);
                    data = Object.assign({}, oldFavorites, {
                        moreSearches: data.moreSearches,
                        searches: newSearches,
                    });
                }

                this.setState({
                    followList: data,
                });
            },
        );
    },

    loadFavorites: function () {
        $.when(getFavList('favTeacherIds'), getFavList('favSchoolIds'), getFavList('favSearchURLs'), getFavList('myGPs')).then(
            (favTeacherIds, favSchoolIds, favSearchHashes, myGPs) => {
                const newState = {
                    favorites: {
                        teacherIds: favTeacherIds,
                        schoolIds: favSchoolIds,
                        searchHashes: favSearchHashes,
                    },
                    donorGivingPages: myGPs,
                };
                this.setState(newState);
            },
        );

        setHeaderMMILink();
        this.loadFollowList(false);
    },

    toggleMobileFilters: function () {
        this.setState({
            showMobileFilters: !this.state.showMobileFilters,
        });
    },

    setDetectedLocation: function (location) {
        this.setState({
            detectedLocation: location,
        });
    },

    setCart: function (cart) {
        this.setState({
            cart: cart,
        });
    },

    isLoading: function () {
        const state = this.state;
        return state.loadingProjects || state.loadingSchools || state.loadingTeachers || state.loadingEssentialsLists;
    },

    // React methods
    getInitialState: function () {
        const props = this.props;
        return {
            callbacks: {
                applyFilters: this.applyFilters,
                changeURL: this.changeURL,
                loadFollowList: this.loadFollowList,
                makeSearchURL: this.makeSearchURL,
                toggleMobileFilters: this.toggleMobileFilters,
                isLoading: this.isLoading,
                toggleGiveWidget: this.toggleGiveWidget,
                loadFavorites: this.loadFavorites,
            },
            getPerPage: this.getPerPage,
            // Only start with the full search URL if we've server-rendered projects
            // If we've only rendered the "outline," we'll start with the base URL and then update it on mount
            searchURL: (props.initialProjects && props.searchURL) || props.baseSearchURL,
            loadingProjects: !props.initialProjects,
            loadingSchools: false,
            loadingTeachers: false,
            loadingEssentialsLists: false,
            showMobileFilters: false,
            detectedLocation: props.initialDetectedLocation,
            projects: {},
            favorites: {},
            donorGivingPages: [],
            cart: {},
            teachers: [],
            schools: [],

            // Avoid re-creating the context object on every render by storing it in state.
            context: {
                isEssentialsListsEnabled: props.isEssentialsListsEnabled,
                isSchoolLevelGivingEnabled: props.isSchoolLevelGivingEnabled,
                isSendLocationSearchToMapEnabled: props.isSendLocationSearchToMapEnabled,
                essentialsData: {},
                essentialsOnly: false,
            },
        };
    },

    UNSAFE_componentWillMount: function () {
        const initialProjects = this.props.initialProjects;
        if (initialProjects) {
            this.setState(this.convertProjectDataToState(initialProjects));
        }
    },

    componentDidMount: function () {
        const props = this.props;
        const searchURL = props.searchURL;

        if (!props.initialProjects) {
            // We need to update the links that were rendered by the server with baseSearchURL
            this.setState({ searchURL });
        }

        // shuffle must be set in the JSP
        // eslint-disable-next-line no-undef
        this.makeRequests(searchURL, shuffle, props.initialProjects);

        setup(this.loadFavorites);
        onSignInOutExecute(this.loadFavorites);
        // UserSmsInfoMixin populates user info to the state

        detectLocation(this.setDetectedLocation, true);
        onCartUpdated(this.setCart);
        handlePopState(this.popState);
    },

    getSearchLayout: function () {
        if (this.state.isMobile) {
            return <SearchLayoutMobile {...this.props} {...this.state} />;
        } else {
            return <SearchLayout {...this.props} {...this.state} />;
        }
    },

    render: function () {
        return (
            <div>
                <SearchContext.Provider value={this.state.context}>
                    {this.getSearchLayout()}
                </SearchContext.Provider>
            </div>
        );
    },

});
